module.exports = __webpack_public_path__ + "img/900694605.9995b214.png";